module.exports = __webpack_public_path__ + "img/banner-1.7c1cdcc0.png";